export async function fetchInteractivityPoll(
  episodeId: string
): Promise<InteractivityPollsResponse> {
  try {
    const response = await fetch(
      `/api/proxy/v3/episodes/webEpisodeId:${episodeId}/poll`
    );
    if (response.ok) {
      return response.json();
    }
    throw new Error('Response not ok');
  } catch (e) {
    console.warn('Error fetching from Interactivity API: ', e);
    throw new Error(e);
  }
}

export type InteractivityPollsResponse = {
  polls: InteractivityPoll[];
};
export type InteractivityPoll = {
  id: number;
  name: string;
  question: string;
  type: POLL_TYPE;
  status?: 'LIVE' | 'DRAFT' | 'CLOSED';
  opening_date?: string;
  closing_date?: string;
  options?: Option[];
  entity_timestamp_ms?: number;
  published?: boolean;
};
export enum POLL_TYPE {
  SINGLE_CHOICE = 'SINGLE_CHOICE',
  MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',
}
export type Option = {
  description: string;
  total_votes?: number;
  poll_id?: number;
  option_id?: number;
};
